import { render, staticRenderFns } from "./view-request-area.vue?vue&type=template&id=0929b84a&"
import script from "./view-request-area.vue?vue&type=script&lang=js&"
export * from "./view-request-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports